import { render } from "./LocalVideoPlayer.vue?vue&type=template&id=d47c3608&scoped=true"
import script from "./LocalVideoPlayer.vue?vue&type=script&lang=js"
export * from "./LocalVideoPlayer.vue?vue&type=script&lang=js"

import "./LocalVideoPlayer.vue?vue&type=style&index=0&id=d47c3608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47c3608"]])

export default __exports__